const versionList = [
  'InputRadio',
  'InputCheckboxTrueFalse',
  'InputCheckboxChooseOne',
  'InputSelect',
  'InputTextbox',
  'InputMultiple',
  'InputSelectMultiple',
  'InputCheckboxTrueFalseSelect',
  'InputCheckboxTrueFalseTextbox',
  'InputCheckboxTrueFalseInfo',
];

export default versionList;
